export default "__VITE_ASSET__BUez$VTO__"